var DropSelect = require('sma.admin/components/dropdowns/dropselect')
var DropSelectorDrilldown = require('sma.admin/components/dropdowns/dropselectordrilldown')

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     items: [{
 *         name: 'subfoo',
 *         text: 'subfoobar',
 *         checked: true
 *     }]
 * }
 */
class DropSelectorBase extends DropSelect {

	initialize (options) {
		this.checkboxItems = false;
		this.selector = true;
		this.noFooter = true;
		this.changeTitleAfterSelection = true;
		this.singleSelect = true;

		options.checkboxItems = false;

		super.initialize(options);
	}

	val (newSelected, change=false) {
		if (newSelected) {
			this.unSelectAll();

			for (let item of this.changedItems) {
				if ((this.singleSelect && item.name === newSelected) ||
					(!this.singleSelect && newSelected.indexOf(item.name) >= 0)
				) {
					item.selected = true;
				}
			}

			this.$selectEl.val(newSelected);
			this.renderItems();

			this.updateTitleFromSelect();
		}

		return this.$selectEl.val();
	}

	get wrapped () {
		return $('<div></div>').append(this.$selectEl).append(this.$el);
	}

}

class DropSelector {
	constructor(options) {
		let instance;
		if (options.$selectEl.find('optgroup').length) {
			instance = new DropSelectorDrilldown(options);
		} else {
			instance = new DropSelectorBase(options);
		}

		return instance;
	}
}

//make new dropselectors for anything with sma-js-dropselector class
$(function () {
	$('.sma-js-dropselector').each((i, item) => {
		new DropSelector({
			$selectEl: $(item),
		})
	});
});

module.exports = DropSelector;
